import React, {Component} from 'react';
import {connect} from 'react-redux';
import pick from 'lodash.pick';

import {Field, Fields, reduxForm} from 'redux-form';
import {
    Col,
    Row
} from 'reactstrap';

import PolyUtil from '../../../util/PolyUtil';
import {guarantorRelationships} from "../../../util/FormConstants";
import {handleSubmitGuarantorConfirm} from "../actions/guarantor";
import {normalizePhone} from "../../../util/normalizers";

import {
    AddressInputField,
    CheckBoxField,
    InputField,
    SelectField
} from "../../../validation/ReduxFormInput";
import FlowButton from "../../../components/flow/PolyFlow/FlowButton";
import {FormAsyncButton} from "../../../components/controls/buttons/AsyncButton";

class ConfirmFrame extends Component {
    render() {

        const {tenant_full_name, confirmed, handleSubmit, _handleSubmitGuarantorConfirm, invalid, pristine, submitting} = this.props;

        return (
            <div>
                {
                    confirmed ? (
                        <div className="mt-4">
                            <Row>
                                <h3>Thank you for confirming your information</h3>
                            </Row>
                            <hr/>
                            <Row>
                                <p>Click the button below to continue to the identity verification and credit check.</p>
                            </Row>
                            <div className="center">
                                <FlowButton id="guarantorFlow" className="mt-4" color="success" outline onClick="inc">Continue</FlowButton>
                            </div>

                            {/*<FlowButton flowId="guarantorFlow" onClick="inc" color="success" outline>Continue</FlowButton>*/}
                        </div>
                    ) : (
                        <div className="mt-4">
                            <Row>
                                <h3>Does all this look correct?</h3>
                            </Row>
                            <hr/>
                            <form onSubmit={handleSubmit(_handleSubmitGuarantorConfirm)} style={{marginBottom: '2rem'}}>
                                <Row>
                                    <Col xs={12} sm={6}><Field name="first_name" label="First Name" component={InputField} type="text"/></Col>
                                    <Col xs={12} sm={6}><Field name="last_name" label="Last Name" component={InputField} type="text"/></Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={6}><Field name="email" label="Email" component={InputField} type="email"/></Col>
                                    <Col xs={12} sm={6}><Field name="phone" label="Primary Phone" placeholder="555-555-5555" component={InputField} normalize={normalizePhone}/></Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Fields names={["place_id", "formatted_address"]} label="Home Address:" placeholder="Begin typing to select an address" helpText="This must be a valid address of a physical residence" component={AddressInputField}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field name="relation" label="Relation" component={SelectField} options={guarantorRelationships}/>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col>
                                        <Field name="checkconfirm"
                                               label={"I hereby confirm that the above information is correct and complete, and I accept and understand the responsibility of acting as a guarantor for " + tenant_full_name +  "."}
                                               component={CheckBoxField}/>
                                    </Col>
                                </Row>

                                <hr/>

                                <div className="center">
                                    <FormAsyncButton acting={submitting}
                                                     type="submit"
                                                     color="success"
                                                     outline
                                                     disabled={invalid || pristine}>
                                        This looks good
                                    </FormAsyncButton>
                                </div>
                            </form>
                        </div>
                    )
                }

            </div>
        );
    }
}

const validate = (values) => {
    const errors = {};

    !values.first_name && (errors.first_name = 'Required');
    !values.last_name && (errors.last_name = 'Required');
    (!values.phone || values.phone.length !== 12) && (errors.phone = 'Please enter a valid phone number');
    !values.email && (errors.email = 'Required');
    (!values.relation || values.relation === 'default') && (errors.relation = 'Required');
    !values.place_id && (errors.place_id = 'Required');

    return errors;
};

ConfirmFrame = reduxForm({
    form: 'guarantor_confirm',
    validate
})(ConfirmFrame);

const mapStateToProps = (state) => {
    const guarantor = state.guarantor;
    let initial = Object.assign({}, pick(guarantor, [
        'first_name',
        'last_name',
        'email',
        'phone',
        'relation'
    ]));

    initial.phone && (initial.phone = PolyUtil.formatPhone(initial.phone));

    return {
        confirmed: state.guarantor.confirmed,
        tenant_full_name: state.guarantor.tenant.first_name + ' ' + state.guarantor.tenant.last_name,
        initialValues: initial,
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    _handleSubmitGuarantorConfirm(data) {
        return dispatch(handleSubmitGuarantorConfirm(data, props.tenant_id, props.tenant_key));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmFrame);



// WEBPACK FOOTER //
// ./src/containers/guarantor/frames/ConfirmFrame.js